import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/schedule` : 'https://backend-c-0mxm.onrender.com/api/schedule';

// Tạo instance axios với cấu hình mặc định
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor để thêm token vào header
api.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    if (user.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Hàm xử lý lỗi chung
const handleError = (error) => {
  if (error.response) {
    return {
      message: error.response.data.message || 'Có lỗi xảy ra từ server',
      status: error.response.status,
    };
  } else if (error.request) {
    return {
      message: 'Không thể kết nối đến server',
      status: 0,
    };
  } else {
    return {
      message: 'Có lỗi xảy ra khi tạo request',
      status: 0,
    };
  }
};

// Lấy tất cả lịch schedules
export const getAllSchedules = async (startDate = null, endDate = null) => {
  try {
    const params = {};
    if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }
    
    const response = await api.get('/', { params });
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Lỗi lấy danh sách lịch:', error);
    return {
      success: false,
      error: handleError(error)
    };
  }
};

// Lấy lịch theo ngày
export const getSchedulesByDate = async (date) => {
  try {
    const normalizedDate = new Date(date);
    normalizedDate.setHours(12, 0, 0, 0);
    const formattedDate = normalizedDate.toISOString().split('T')[0];
    
    const response = await api.get(`/date/${formattedDate}`);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Lỗi lấy lịch theo ngày:', error);
    return {
      success: false,
      error: handleError(error)
    };
  }
};

// Lấy lịch theo user
export const getSchedulesByUser = async (userId, startDate = null, endDate = null) => {
  try {
    const params = {};
    if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    }
    
    const response = await api.get(`/user/${userId}`, { params });
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Lỗi lấy lịch theo user:', error);
    return {
      success: false,
      error: handleError(error)
    };
  }
};

// Tạo lịch mới
export const createSchedule = async (scheduleData) => {
  try {
    const response = await api.post('/', scheduleData);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Lỗi tạo lịch:', error);
    return {
      success: false,
      error: handleError(error)
    };
  }
};

// Cập nhật lịch
export const updateSchedule = async (scheduleId, scheduleData) => {
  try {
    const response = await api.put(`/${scheduleId}`, scheduleData);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Lỗi cập nhật lịch:', error);
    return {
      success: false,
      error: handleError(error)
    };
  }
};

// Xóa lịch
export const deleteSchedule = async (scheduleId) => {
  try {
    const response = await api.delete(`/${scheduleId}`);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Lỗi xóa lịch:', error);
    return {
      success: false,
      error: handleError(error)
    };
  }
};

// Xử lý hàng loạt (batch processing)
export const batchScheduleAction = async (scheduleIds, action) => {
  try {
    const response = await api.post('/batch', {
      ids: scheduleIds,
      action: action
    });
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Lỗi xử lý hàng loạt:', error);
    return {
      success: false,
      error: handleError(error)
    };
  }
}; 